export const baseurl = {
  dev: 'dev-www.myglance.org',
  dw1: 'dw1.myglance.org',
  dw2: 'dw2.myglance.org',
  dw3: 'dw3.myglance.org',
  dw4: 'dw4.myglance.org',
  qa: 'qa.myglance.org',
  staging: 'www.myglance.net',
  beta: 'beta.glance.net',
  production: 'www.glance.net',
};

export const translationsurl = {
  dev: 's3.amazonaws.com/devglancecdn',//It may change to devglancecdn.s3.amazonaws.com
  staging: 'cdnstorage.myglance.net',
  production: 'storage.glancecdn.net',
};
